<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>أقساط العروض المتأخرة</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='panel panel-default'>
                            <div class='panel-heading'>
                          هنا يتم عرض اقساط العروض المتأخرة حتى تاريخة

                              <div class='pull-left' style='padding=0px'>
                                <button v-simple-print="'contentToPrint'" type='button' class='btn btn-outline btn-primary btn-md btn-block ' style='padding:3px;width: 60px'>
                                  <b> طباعة </b>
                                </button>
                                </div>
                              </div>
                            <!-- /.panel-heading -->
                            <div class='panel-body'>
                                <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='validationErrors'>
                                  <ul v-if='validationErrors'>
                                    <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                                  </ul>
                                </div>
                                <div class="col-lg-12 ">
                                  <div class='col-lg-3 col-md-3 col-sm-6' style="padding: 3px">
                                    <label>الفرع</label>
                                    <select  @change='FillItineraries()' class="form-control" style="padding: 0px"  v-model="brancheID">
                                      <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                                        {{ item.name }}
                                      </option>
                                    </select>
                                  </div>
                                  <div class='col-lg-3 col-md-3 col-sm-6' style="padding: 3px">
                                    <label>الخط</label>
                                    <select class="form-control" style="padding: 0px" v-model="line">
                                      <option v-for="item in lines" v-bind:key="item.id" v-bind:value="item.id">
                                        {{ item.name }}
                                      </option>
                                    </select>
                                  </div>
                                  <div class='col-lg-3 col-md-3 col-sm-6' style="padding: 3px">
                                    <label>&nbsp;</label>
                                    <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-lg btn-block' style='padding:3px'>
                                      <b> عرض </b>
                                    </button>
                                  </div>
                                </div>
                                    <div id="contentToPrint">
                                      <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                          <thead>
                                            <tr>
                                              <th style='padding:2px;text-align: center'>م</th>
                                              <th style='padding:2px;text-align: center'>الكود</th>
                                              <th style='padding:2px;text-align: center'>الاسم</th>
                                              <th style='padding:2px;text-align: center'>المنطقة</th>
                                              <th style='padding:2px;text-align: center'>العرض</th>
                                              <th style='padding:2px;text-align: center'>آخر سداد</th>
                                              <th style='padding:2px;text-align: center'>دورة السداد</th>
                                              <th style='padding:2px;text-align: center'>القسط المتأخر</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                              <tr class='odd gradeX' v-for='(record,index) in record' :key='record.id'>

                                                 <td align='center'>{{index +1 }}</td>
                                                 <td align='center'>{{record.rec_id}}</td>
                                                 <td align='right'>{{record.name}}</td>
                                                 <td align='center'>{{record.region_name}}</td>
                                                 <td align='center'>{{record.offer_name}}</td>
                                                 <td align='center'>{{record.date}}</td>
                                                 <td align='center'>{{record.period}}</td>
                                                 <td align='center'>{{record.next_installment}}</td>
                                              </tr>
                                          </tbody>
                                      </table>
                                    </div>
                                <!-- /.table-responsive -->
                            </div>
                            <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- /.container-fluid -->
        </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'OffersInstallmentsArrears',
  data () {
    return {
      emptyRec: [{id: 0, name: 0}],
      brancheID: 0,
      itinerarie: 0,
      branches: {},
      record: {},
      lines: {},
      line: '',
      validationErrors: '',
      isLoadingData: false
    }
  },
  created () {
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.brancheID = localStorage.getItem('BrancheID')
    this.FillItineraries()
  },
  methods: {
    FillItineraries () {
      this.line = ''
      let i = this.branches.findIndex(x => x.id === parseInt(this.brancheID))
      if (i > -1) {
        this.lines = JSON.parse(JSON.stringify(this.branches[i].itineraries))
        this.line = 0
      }
    },
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'offers-installments-arrears', {
        token: localStorage.getItem('token'),
        branch_id: this.brancheID,
        line: this.line
      })
        .then(({ data }) => {
          this.record = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Reports/OffersInstallmentsArrears.vue